import { CaseData } from "@/cms/models";
import AreaDetail from "../AreaDetails";
import TextDetails from "../TextDetails";

const PlotOfLandPropertyFacts: React.FC<{ caseData: CaseData }> = ({
  caseData,
}) => {
  return (
    <div className="p-4 bg-[var(--card-bg-color)] text-[var(--card-text-color)] homepage-text-sm">
      {caseData.plotArea > 0 && (
        <AreaDetail label="Grundareal" value={caseData.plotArea} />
      )}
      {caseData.caseNumber && (
        <TextDetails label="Sagsnummer" value={caseData.caseNumber} />
      )}
      {caseData.estateType && (
        <TextDetails label="Ejendomstype" value={caseData.estateType} />
      )}
    </div>
  );
};

export default PlotOfLandPropertyFacts;
